import React, {useState} from 'react';
import logo from '../assets/icon-hi-blinds.jpg'
import menuImg from '../assets/navigation-menu.svg'
import closeImg from '../assets/close-svgrepo-com.svg'
import styled from 'styled-components';
import { NavLink, Link } from 'react-router';

const Header = () => {
    const [isButton1Open, setIsButton1Open] = useState(true);

    const disableScroll = () => {
      document.body.style.overflow = "hidden";
    };

    const enableScroll = () => {
      document.body.style.overflow = "auto"; 
     
    };;
    
    const handleButtonClick = (buttonId) => {
      if (buttonId === "open") {
        setIsButton1Open(true);
        enableScroll()
      } else {
        setIsButton1Open(false); 
        disableScroll()
      }
    };


    return ( 
        <HeaderStyle>
            <IconContainer>
                <Icon src={logo} alt='logo'/>
                <h2>
                    <Link to='/'>
                        Hi Blinds
                    </Link> 
                </h2>
            </IconContainer>
            <MenuContainer className={!isButton1Open ? "openNavBar" : "closeNavBar"} >
                <NavLink onClick={() => handleButtonClick("open")}  to='/pertina'>Pertina</NavLink>
                <NavLink onClick={() => handleButtonClick("open")}  to='/telas-para-cortina-y-confección'>Telas para cortina</NavLink>
                <NavLink onClick={() => handleButtonClick("open")}  to='/persianas'>Persianas</NavLink>
                <NavLink onClick={() => handleButtonClick("open")}  to='/telas-premium-vertilux'>Telas prémium</NavLink>
            </MenuContainer>
            <MenuImgContainer>
                <MenuImg 
                    className={isButton1Open ? "open-menu" : "close-menu"} 
                    onClick={() =>  handleButtonClick("close")}  
                    src={menuImg} alt='Open' 
                />
                <MenuImg 
                    className={!isButton1Open ? "open-menu" : "close-menu"} 
                    onClick={() => handleButtonClick("open")} 
                    src={closeImg} alt='Close' 
                />
            </MenuImgContainer>
        </HeaderStyle>
     );
    
}

const HeaderStyle = styled.header ` 
    display: grid;
    grid-template-columns: 8fr  1fr;
    grid-template-rows: 1fr;
    position: fixed;
    background-color: #000000e3;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    width: 100%;
    z-index: 1000;
    top: 0;
    
    .openNavBar {
        transform: translateY(0);
    }
`
const IconContainer = styled.div `
    display: grid;
    grid-template-columns: 1fr 9fr;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    max-height: 60px;
    color: #fff;
    
    h2 > a{
        text-decoration: none;
        color: #fff;
    }
`
const Icon = styled.img `
    min-width: 60px;
    max-height: 60px;
`
const MenuContainer = styled.nav `
    background-color: #000000bf;
    backdrop-filter: blur(5px);
    position: fixed;
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    transform: translateX(102vw);
    transition: transform .6s;

    a {
        text-decoration: none;
        background-color: #fff;
        padding: 15px 25px;
        width: 80%;
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(129, 129, 129, 0.1);
        font-weight: bold;
        transition: transform .3s;
        text-align: center;
        font-size: large;
        color: #000000;
    }
    a:active {
        transform: scale(.7);
    }
    
`
const MenuImgContainer = styled.div `
    min-width: 50px;
    min-width: 50px;
    grid-column: -1 / -2;
    grid-row: -1 / -2;
    display: flex;
    justify-content: center;
    align-items: center;

    .open-menu {
        transform: scale(1);
    }.close-menu {
        transform: scale(0);
    }
`
const MenuImg = styled.img `
    max-width: 40px;
    max-width: 40px;
    position: fixed;
    transition: transform .5s;
    transform: scale(1);
    filter: invert(1);
`

export default Header;